import { render } from "./TvmLoginVehicles.vue?vue&type=template&id=b2020d94"
import script from "./TvmLoginVehicles.vue?vue&type=script&lang=js"
export * from "./TvmLoginVehicles.vue?vue&type=script&lang=js"

import "./TvmLoginVehicles.vue?vue&type=style&index=0&id=b2020d94&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__